import {
  GET_NOMINATION_LIST_FAILURE,
  GET_NOMINATION_LIST_REQUEST,
  GET_NOMINATION_LIST_RESET,
  GET_NOMINATION_LIST_SUCCESS,
} from "../../../../redux/types/awards"

const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
}

const getNominationListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOMINATION_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        message: "",
        error: "",
        success: false,
      }

    case GET_NOMINATION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        error: "",
        success: true,
      }

    case GET_NOMINATION_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        message: "",
        error: action.payload.error,
        success: false,
      }

    case GET_NOMINATION_LIST_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default getNominationListReducer
